import React from 'react';
import moment from 'moment';

import { computeOrderTotal, getOrderComponentClassNames } from '../../helpers/orders';
import { cancel, close, pay, remove } from '../../apis/orders';
import { formatMoney } from '../../helpers/formatters';

import { OrderActionButton } from '../orders/OrderActionButton';
import { OrderChildRow } from '../orders/OrderChildRow';
import { LightIcon } from '../common/icons/LightIcon';

export const UserOrdersListItem = ({ row: order, showChildRow, onShowChildRow, onRefresh }) => {
    const useItemPrice = true;
    const orderTotal = computeOrderTotal(order.items, useItemPrice);

    const {
        itemClassName,
        labelClassName,
        badgeClassName,
        textStartClassName,
        textEndClassName,
        secondaryButtonClassName,
        primaryButtonClassName
    } = getOrderComponentClassNames(order, showChildRow);

    return (
        <React.Fragment>
            <li className={itemClassName}>
                <div className="row">
                    <div className="mode-cell col-lg-1 col-xl-1 d-none d-lg-block">
                        <p className="text-center my-1">
                            <button
                                className={secondaryButtonClassName}
                                onClick={() => onShowChildRow(order)}>
                                <LightIcon
                                    icon={showChildRow ? 'minus' : 'plus'}
                                    iconClassName="fa-fw"
                                    color="default"
                                />
                            </button>
                        </p>
                    </div>
                    <div className="date-cell col-lg-3 col-xl-2 d-flex justify-content-between">
                        <label className={labelClassName}>Date</label>
                        <p className={textStartClassName}>
                            {moment(order.date).format('YYYY/MM/DD')}
                        </p>
                    </div>
                    <div className="status-cell col-lg-2 col-xl-2 d-flex justify-content-between">
                        <label className={labelClassName}>Status</label>
                        <p className={`text-end text-lg-center w-100 my-1`}>
                            <span className={badgeClassName}>{order.status}</span>
                        </p>
                    </div>
                    <div className="total-cell col-lg-3 col-xl-4 d-flex justify-content-between">
                        <label className={labelClassName}>Total</label>
                        <p className={textEndClassName}>{formatMoney(orderTotal)}</p>
                    </div>
                    <div className="actions-cell col-lg-3 col-xl-3 d-flex justify-content-between">
                        <label className={labelClassName}>Actions</label>
                        <p className="text-end w-100 my-1">
                            {order.status == 'Open' && (
                                <OrderActionButton
                                    tooltipText="Pay"
                                    onSucceed={onRefresh}
                                    action={() => pay(order.id)}
                                    className={`${primaryButtonClassName} ms-2`}
                                    confirmationText="Do you want to pay this order?">
                                    <span className="far fa-dollar-sign fa-fw"></span>
                                </OrderActionButton>
                            )}
                            {order.status == 'Open' && (
                                <OrderActionButton
                                    tooltipText="Cancel"
                                    onSucceed={onRefresh}
                                    action={() => cancel(order.id)}
                                    className={`${primaryButtonClassName} ms-2`}
                                    confirmationText="Do you want to cancel this order?">
                                    <span className="far fa-ban fa-fw"></span>
                                </OrderActionButton>
                            )}
                            {order.status == 'Paid' && (
                                <OrderActionButton
                                    tooltipText="Close"
                                    onSucceed={onRefresh}
                                    action={() => close(order.id)}
                                    className={`${primaryButtonClassName} ms-2`}
                                    confirmationText="Do you want to close this order?">
                                    <span className="far fa-stamp fa-fw"></span>
                                </OrderActionButton>
                            )}
                            {(order.status == 'Cancelled' || order.status == 'Closed') && (
                                <OrderActionButton
                                    tooltipText="Remove"
                                    onSucceed={onRefresh}
                                    action={() => remove(order.id)}
                                    className={`${primaryButtonClassName} ms-2`}
                                    confirmationText="Do you want to remove this order?">
                                    <span className="far fa-trash fa-fw"></span>
                                </OrderActionButton>
                            )}
                        </p>
                    </div>
                    <div className="d-grid d-block d-lg-none my-3 ">
                        <button
                            className={primaryButtonClassName}
                            onClick={() => onShowChildRow(order)}>
                            <LightIcon
                                icon={showChildRow ? 'minus' : 'plus'}
                                iconClassName="fa-fw"
                                color="default"
                            />
                        </button>
                    </div>
                </div>
            </li>
            {showChildRow && <OrderChildRow order={order} />}
        </React.Fragment>
    );
};
